import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdministrativoModule } from '../administrativo/administrativo.module';
import { FinanceiroModule } from '../financeiro/financeiro.module';
import { FinanceiroRoutingModule } from '../financeiro/router/financeiro.router';
import { FinanceiroService } from '../financeiro/service/financeiro.service';
import { AcessoLinksDocumentosModule } from '../institucional/acesso-links-documentos/acesso-links-documentos.module';
import { PlanosModule } from '../planos/planos.module';
import { AreaRestritaSharedModule } from '../shared/area-restitra.shared.module';
import { EnderecoCadastroService } from '../shared/services/endereco-cadastro.service';
import { PessoaService } from '../shared/services/pessoa.service';
import { ValidarPermissaoFuncionalidadeService } from '../shared/services/validar-permissao-funcionalidades.service';
import { FuncoesCardMenu } from '../shared/util/funcaoes-card-menu/funcoes-card-menu';
import { CardMenuAdministrativoComponent } from './card-menu-administrativo/card-menu-administrativo.component';
import { CardMenuFinanceiroComponent } from './card-menu-financeiro/card-menu-financeiro.component';
import { CardMenuInstitucionalComponent } from './card-menu-institucional/card-menu-institucional.component';
import { CardMenuPessoalComponent } from './card-menu-pessoal/card-menu-pessoal.component';
import { CardMenuPlanosComponent } from './card-menu-planos/card-menu-planos.component';
import { CardMenuComponent } from './card-menu.component';
import { CardMenuRoutingModule } from './router/card-menu.router';
import { CardsMenuService } from './service/cards-menu.service';
import { CardMenuEleicaoComponent } from './card-menu-eleicao/card-menu-eleicao.component';


@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        FinanceiroRoutingModule,
        CardMenuRoutingModule,
        FinanceiroModule,
        PlanosModule,
        AdministrativoModule,
        AcessoLinksDocumentosModule
    ],
    declarations: [
        CardMenuFinanceiroComponent,
        CardMenuPlanosComponent,
        CardMenuAdministrativoComponent,
        CardMenuPessoalComponent,
        CardMenuInstitucionalComponent,
        CardMenuComponent,
        CardMenuEleicaoComponent
    ],
    exports: [
        CardMenuComponent
    ],
    providers: [
        FinanceiroService,
        CardsMenuService,
        PessoaService,
        EnderecoCadastroService,
        FuncoesCardMenu,
        ValidarPermissaoFuncionalidadeService
    ]
})
export class CardMenuModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/card-menu/card-menu.module.ts